import { BookOpen, Users, FileCheck, Wallet, ShieldCheck, MessagesSquare, Dice5 } from "lucide-react";

const services = [
  {
    icon: BookOpen,
    title: "Löpande bokföring",
    desc: "Vi hanterar kvitton, fakturor och utlägg månad för månad. Styrelsen får tydliga rapporter på exakt hur ekonomin mår.",
  },
  {
    icon: Wallet,
    title: "Ekonomihantering",
    desc: "Budget, betalningar, leverantörsfakturor och avstämningar. Vi ser till att kassaflödet är under kontroll.",
  },
  {
    icon: Users,
    title: "Medlemshantering",
    desc: "Medlemsavgifter, register och GDPR-säker hantering. Ingen medlem faller mellan stolarna.",
  },
  {
    icon: FileCheck,
    title: "Årsredovisning & deklaration",
    desc: "Bokslut, årsredovisning och deklarationer som klarar revisorns granskning.",
  },
  {
    icon: ShieldCheck,
    title: "Myndighetskontakter",
    desc: "Skatteverket, Bolagsverket och andra instanser. Vi sköter dialogen så styrelsen slipper huvudvärken.",
  },
  {
    icon: MessagesSquare,
    title: "Styrelsestöd",
    desc: "Bollplank inför möten, årsmöteshandlingar och rådgivning när formella krav blir kluriga.",
  },
  {
    icon: Dice5,
    title: "Regelefterlevnad lotteri & spel",
    desc: "Lotteritillstånd, redovisning och Spelinspektionens krav. Vi ser till att föreningens lotterier sköts korrekt.",
  },
];

export const Services = () => {
  return (
    <section id="tjanster" className="bg-surface rounded-t-[2.5rem] lg:rounded-t-[3rem] px-6 lg:px-8 pt-20 lg:pt-28 pb-24 lg:pb-32 ring-1 ring-ink/5">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <span className="text-xs font-medium tracking-widest uppercase text-oak mb-4 block">Våra tjänster</span>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight text-balance mb-5">
              Administration för eldsjälar.
            </h2>
            <p className="text-lg text-ink-muted leading-relaxed text-pretty">
              Ni brinner för er sak, inte för kvitton och debet-kredit. Vi tar hand om resten.
            </p>

          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <article
              key={s.title}
              className="bg-paper p-7 rounded-2xl ring-1 ring-ink/5 shadow-soft hover:ring-oak/30 hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              <div className="size-12 rounded-xl bg-surface-deep flex items-center justify-center mb-6 text-oak">
                <s.icon className="size-5" />
              </div>
              <h3 className="font-display text-xl text-ink mb-3">{s.title}</h3>
              <p className="text-ink-muted text-sm leading-relaxed">{s.desc}</p>
              <span className="text-xs font-medium tabular-nums text-ink-muted mt-6">0{i + 1}</span>
            </article>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-4">
          <a
            href="/tjanster/bokforing-forening"
            className="inline-flex items-center gap-2 text-ink font-medium hover:text-oak transition-colors"
          >
            Läs mer om bokföring för föreningar
            <span aria-hidden>→</span>
          </a>
        </div>
      </div>
    </section>
  );
};